// PRIVA Shopify Theme JavaScript

// Loader
window.addEventListener('load', () => {
  setTimeout(() => {
    const loader = document.getElementById('loader');
    if (loader) loader.classList.add('hide');
  }, 1200);
});

// Nav scroll
window.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');
  if (header) header.classList.toggle('scrolled', window.scrollY > 50);
});

// Mobile menu
document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.getElementById('menuToggle');
  const mobileMenu = document.getElementById('mobileMenu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      const spans = menuToggle.querySelectorAll('span');
      if (mobileMenu.classList.contains('open')) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        spans[0].style.transform = 'none';
        spans[1].style.opacity = '1';
        spans[2].style.transform = 'none';
      }
    });
  }

  // Close menu on link click (but not on dropdown toggle buttons)
  document.querySelectorAll('.mobile-menu a').forEach(link => {
    link.addEventListener('click', () => {
      if (mobileMenu) mobileMenu.classList.remove('open');
      const spans = menuToggle ? menuToggle.querySelectorAll('span') : [];
      spans.forEach(s => { s.style.transform = 'none'; s.style.opacity = '1'; });
      // Reset dropdowns
      document.querySelectorAll('.mobile-dropdown-menu.open').forEach(m => {
        m.classList.remove('open');
        m.previousElementSibling.classList.remove('open');
      });
    });
  });

  // Featured Slider
  initFeaturedSlider();

  // Scroll reveal
  initScrollReveal();

  // Smooth anchor scroll
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  // Nav dropdowns (prevent parent click)
  initNavDropdowns();

  // Mobile dropdown accordion
  initMobileDropdowns();

  // Search dropdown
  initSearchDropdown();

  // Lightbox
  initLightbox();

  // Lookbook slider
  initLookbookSlider();

  // Add to cart forms
  initAddToCart();
});

// Featured Slider
function initFeaturedSlider() {
  const featuredTrack = document.getElementById('featuredTrack');
  const dotsContainer = document.getElementById('featuredDots');
  if (!featuredTrack || !dotsContainer) return;

  let featuredIndex = 0;
  const totalSlides = featuredTrack.children.length;

  for (let i = 0; i < totalSlides; i++) {
    const dot = document.createElement('div');
    dot.className = 'slider-dot' + (i === 0 ? ' active' : '');
    dot.onclick = () => goToSlide(i);
    dotsContainer.appendChild(dot);
  }

  function slideFeatured(dir) {
    featuredIndex = (featuredIndex + dir + totalSlides) % totalSlides;
    updateSlider();
  }
  function goToSlide(i) { featuredIndex = i; updateSlider(); }
  function updateSlider() {
    featuredTrack.style.transform = `translateX(-${featuredIndex * 100}%)`;
    document.querySelectorAll('.slider-dot').forEach((d, i) =>
      d.classList.toggle('active', i === featuredIndex));
  }

  // Auto slide
  let autoSlide = setInterval(() => slideFeatured(1), 5000);
  const slider = document.querySelector('.featured-slider');
  if (slider) {
    slider.addEventListener('mouseenter', () => clearInterval(autoSlide));
    slider.addEventListener('mouseleave', () => {
      autoSlide = setInterval(() => slideFeatured(1), 5000);
    });
  }

  // Touch support
  let touchStartX = 0;
  featuredTrack.addEventListener('touchstart', e => {
    touchStartX = e.touches[0].clientX;
    clearInterval(autoSlide);
  }, { passive: true });
  featuredTrack.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) slideFeatured(diff > 0 ? 1 : -1);
    autoSlide = setInterval(() => slideFeatured(1), 5000);
  }, { passive: true });

  // Expose to global for button onclick
  window.slideFeatured = slideFeatured;
}

// Scroll Reveal
function initScrollReveal() {
  const reveals = document.querySelectorAll('.reveal');
  if (!reveals.length) return;

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  reveals.forEach(el => revealObserver.observe(el));
}

// Add to Cart (Shopify AJAX API)
function initAddToCart() {
  document.querySelectorAll('.product-form form, form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.textContent = 'Adding...';
        submitBtn.disabled = true;
      }

      try {
        const response = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          if (submitBtn) submitBtn.textContent = 'Added!';
          updateCartCount();
          setTimeout(() => {
            if (submitBtn) {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }
          }, 1500);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (err) {
        if (submitBtn) {
          submitBtn.textContent = 'Error';
          submitBtn.disabled = false;
          setTimeout(() => { submitBtn.textContent = originalText; }, 1500);
        }
      }
    });
  });
}

// Mobile Dropdown Accordion
function initMobileDropdowns() {
  document.querySelectorAll('.mobile-dropdown-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const menu = btn.nextElementSibling;
      const isOpen = menu.classList.contains('open');

      // Close all other dropdowns
      document.querySelectorAll('.mobile-dropdown-menu.open').forEach(m => {
        m.classList.remove('open');
        m.previousElementSibling.classList.remove('open');
      });

      // Toggle this one
      if (!isOpen) {
        menu.classList.add('open');
        btn.classList.add('open');
      }
    });
  });
}

// Search Dropdown with Predictive Search
function initSearchDropdown() {
  const toggle = document.getElementById('searchToggle');
  const dropdown = document.getElementById('searchDropdown');
  const input = document.getElementById('searchInput');
  const close = document.getElementById('searchClose');
  const resultsContainer = document.getElementById('searchResults');
  if (!toggle || !dropdown) return;

  let debounceTimer = null;

  toggle.addEventListener('click', () => {
    dropdown.classList.toggle('open');
    if (dropdown.classList.contains('open') && input) {
      setTimeout(() => input.focus(), 300);
    }
  });

  function closeSearch() {
    dropdown.classList.remove('open');
    if (input) input.value = '';
    if (resultsContainer) resultsContainer.innerHTML = '';
  }

  if (close) close.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && dropdown.classList.contains('open')) closeSearch();
  });

  if (input && resultsContainer) {
    input.addEventListener('input', () => {
      const query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        resultsContainer.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(() => fetchSearchResults(query), 300);
    });
  }

  async function fetchSearchResults(query) {
    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`
      );
      const data = await response.json();
      const products = data.resources.results.products || [];

      if (products.length === 0) {
        resultsContainer.innerHTML = '<div class="search-no-results">No products found</div>';
        return;
      }

      resultsContainer.innerHTML = products.map(product => {
        const img = product.image
          ? `<img src="${product.image}" alt="${product.title}" loading="lazy">`
          : `<div class="search-result-placeholder"></div>`;
        const price = product.price
          ? `<span class="search-result-price">${formatMoney(product.price)}</span>`
          : '';
        return `
          <a href="${product.url}" class="search-result-item">
            <div class="search-result-img">${img}</div>
            <div class="search-result-info">
              <span class="search-result-title">${product.title}</span>
              ${price}
            </div>
          </a>`;
      }).join('') + `<a href="/search?q=${encodeURIComponent(query)}" class="search-view-all">View all results</a>`;
    } catch (err) {
      resultsContainer.innerHTML = '<div class="search-no-results">Something went wrong</div>';
    }
  }

  function formatMoney(cents) {
    return '$' + (parseFloat(cents) / 100).toFixed(2).replace(/\.00$/, '');
  }
}

// Prevent parent nav links with dropdowns from navigating
function initNavDropdowns() {
  document.querySelectorAll('.has-dropdown > a[href="#"]').forEach(link => {
    link.addEventListener('click', (e) => e.preventDefault());
  });
}

// Lightbox for PRIVA World images
function initLightbox() {
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightboxImg');
  if (!lightbox || !lightboxImg) return;

  const items = document.querySelectorAll('.insta-item[data-lightbox-index]');
  if (!items.length) return;

  // Collect full-res image URLs
  const images = [];
  items.forEach(item => {
    const fullSrc = item.querySelector('.insta-full-src');
    if (fullSrc) {
      images.push(fullSrc.src);
    }
  });

  let currentIndex = 0;

  function openLightbox(index) {
    currentIndex = index;
    lightboxImg.src = images[currentIndex];
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('open');
    document.body.style.overflow = '';
  }

  function navigate(dir) {
    currentIndex = (currentIndex + dir + images.length) % images.length;
    lightboxImg.src = images[currentIndex];
  }

  // Click on thumbnail to open
  items.forEach((item, i) => {
    item.style.cursor = 'pointer';
    item.addEventListener('click', () => openLightbox(i));
  });

  // Close button
  lightbox.querySelector('.lightbox-close').addEventListener('click', closeLightbox);

  // Arrow buttons
  lightbox.querySelector('.lightbox-prev').addEventListener('click', (e) => { e.stopPropagation(); navigate(-1); });
  lightbox.querySelector('.lightbox-next').addEventListener('click', (e) => { e.stopPropagation(); navigate(1); });

  // Click background to close
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox || e.target.classList.contains('lightbox-img-wrap')) {
      closeLightbox();
    }
  });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!lightbox.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') navigate(-1);
    if (e.key === 'ArrowRight') navigate(1);
  });
}

// Campaign Dual-Panel Slideshows (each panel slides independently)
function initLookbookSlider() {
  const trackLeft = document.getElementById('campaignTrackLeft');
  const trackRight = document.getElementById('campaignTrackRight');
  if (!trackLeft && !trackRight) return;

  function setupPanelSlider(track) {
    if (!track) return null;
    const count = track.children.length;
    if (count <= 1) return null;

    let index = 0;

    function slide() {
      index = (index + 1) % count;
      track.style.transform = `translateY(-${index * 100}%)`;
    }

    return { slide, count };
  }

  const left = setupPanelSlider(trackLeft);
  const right = setupPanelSlider(trackRight);

  // Read speed from customizer settings (in seconds, convert to ms)
  const wrapper = document.querySelector('.campaign-dual');
  const leftSpeed = wrapper ? (parseFloat(wrapper.dataset.leftSpeed) || 4) * 1000 : 4000;
  const rightSpeed = wrapper ? (parseFloat(wrapper.dataset.rightSpeed) || 5) * 1000 : 5000;

  if (left) setInterval(left.slide, leftSpeed);
  if (right) setTimeout(() => { if (right) setInterval(right.slide, rightSpeed); }, 2000);

  // Touch support
  [trackLeft, trackRight].forEach(track => {
    if (!track) return;
    const count = track.children.length;
    if (count <= 1) return;
    let idx = 0;
    let touchStartY = 0;
    track.addEventListener('touchstart', e => {
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    track.addEventListener('touchend', e => {
      const diff = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(diff) > 50) {
        idx = (idx + (diff > 0 ? 1 : -1) + count) % count;
        track.style.transform = `translateY(-${idx * 100}%)`;
      }
    }, { passive: true });
  });
}

// Update cart count badge
async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch (err) {
    console.error('Failed to update cart count', err);
  }
}
